import { RouteComponentProps } from 'react-router-dom'
import type { HomeId } from '@racepointenergy/swc/scs/types'

import PowerFlow from './PowerFlow'
import LoadStatus from './LoadStatus'
import SystemStatus from './SystemStatus'
import MessageCenter from './MessageCenter'

interface HomeEnergySystemProps
  extends RouteComponentProps<{ rootDomainId: string; homeId: HomeId }> {}

function HomeEnergySystem({ match }: HomeEnergySystemProps) {
  const { rootDomainId, homeId } = match.params

  return (
    <div>
      <SystemStatus id={rootDomainId} homeId={homeId} />
      <PowerFlow homeId={homeId} />

      <MessageCenter homeId={homeId} />

      <LoadStatus homeId={homeId} />
    </div>
  )
}

export default HomeEnergySystem
